/**
 * Checks if the browser's popup blocker is enabled.
 * @returns {boolean} Returns true if the popup blocker is enabled, false otherwise.
 */
export function isPopupBlocked() {
  let isBlocked = false;

  const popup = window.open('', '_blank', 'width=1,height=1,left=-1000,top=-1000');

  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    isBlocked = true;
  } else {
    popup.close();
  }

  return isBlocked;
}
